import { useEffect, useState } from "react";

const HomeStore = () =>{

    return(<> 

<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center">
                   
                    <div className="col-lg-12">
                        <div className="about-content" style={{textAlign:"center"}}>
                           <h2 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Home Store</h2>
                           
						
							
                        </div>
                    </div>
                </div>
				
				
				
				
            </div>
        </div>
    </section>

    </>);

}

export default HomeStore;